<template>
  <div :height="true" class="showTask">
    <!-- <div class="goback">
      <span @click="$router.back()">返回</span>
    </div> -->
    <div class="base-info">
      <div class="top font-bold">基本信息</div>
      <el-form :model="baseInfo" ref="taskRuleForm" :rules="baseInfoRules" label-width="140px" label-position="right">
        <el-form-item label="任务ID:">
          {{ baseInfo.id }}
        </el-form-item>
        <el-form-item label="任务名称:" prop="executionName">
          <el-input v-model="baseInfo.executionName"></el-input>
        </el-form-item>
        <el-form-item label="调查员手机号:">
          {{ baseInfo.executorPhone }}
        </el-form-item>
        <el-form-item prop="executionValidateTo" label="截止时间:">
          <el-date-picker
            class="el-form-input"
            type="datetime"
            placeholder="选择日期"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            v-model="baseInfo.executionValidateTo"
            :picker-options="startDateDisabled"
          />
        </el-form-item>
        <el-form-item :style="{ marginBottom: '0' }" label="结算类型：" prop="settleMethod">
          <div class="flex">
            <div class="inline-block">
              <div
                class="btn-box btn1 box-border"
                :class="{ 'btn-checked': btnChecked == 'online' }"
                @click="changeSettleMethod('online')"
              >
                <el-checkbox class="position-checkbox" :disabled="!(btnChecked == 'online')" :value="true"></el-checkbox>
                <div>
                  <div class="text-theme-black-650 text-medium mb-2 font-semibold">
                    线上结算
                    <div class="tujian bg-yellow-theme text-white inline-block text-center font-semibold text-small">推荐</div>
                  </div>
                  <div class="text-theme-black-450 text-small">
                    线上支付调查员费用，调研工厂代调查员纳税，并为您的总花费开具发票
                  </div>
                  <div class="flex justify-between mt-1" v-if="!isOpen">
                    <span class="text-yellow-theme text-small">
                      <i class="iconfont icon-jingshishuoming text-small font-semibold"></i>
                      尚未开通，无法使用
                    </span>
                    <span class="cursor-pointer text-theme text-small" @click="toOpen">去开通></span>
                  </div>
                </div>
              </div>
            </div>
            <div class="inline-block">
              <div
                class="btn-box btn2 box-border"
                :class="{ 'btn-checked': btnChecked == 'offline' }"
                @click="changeSettleMethod('offline')"
              >
                <el-checkbox class="position-checkbox" :disabled="!(btnChecked == 'offline')" :value="true"></el-checkbox>
                <div>
                  <div class="text-theme-black-650 text-medium mb-2 font-semibold">线下结算</div>
                  <div class="text-theme-black-450 text-small">常用场景：线下与调查员签署劳务协议、协商支付方式、纳税事宜等</div>
                </div>
              </div>
            </div>
            <div class="inline-block">
              <div
                class="btn-box btn2 box-border"
                :class="{ 'btn-checked': btnChecked == 'neednot' }"
                @click="changeSettleMethod('neednot')"
              >
                <el-checkbox class="position-checkbox" :disabled="!(btnChecked == 'neednot')" :value="true"></el-checkbox>
                <div>
                  <div class="text-theme-black-650 text-medium mb-2 font-semibold">无需结算</div>
                  <div class="text-theme-black-450 text-small">常用场景：已同调查员签署劳动合同或调查员愿提供无偿服务等</div>
                </div>
              </div>
            </div>
          </div>
        </el-form-item>
        <el-form-item
          :style="{ marginBottom: baseInfo.settleMode ? '0' : '18px' }"
          label="结算方式："
          prop="settleMode"
          :rules="[{ required: !(!isOpen && baseInfo.settleMethod == 0), message: ' ', trigger: 'change' }]"
        >
          <el-radio-group
            v-model="baseInfo.settleMode"
            @change="changeSettlementType"
            :disabled="!isOpen && baseInfo.settleMethod == 0"
          >
            <el-radio :label="1">按答卷数量</el-radio>
            <el-radio :label="2">按天</el-radio>
            <el-radio v-if="!(btnChecked == 'neednot')" :label="3">按阶梯计价</el-radio>
          </el-radio-group>
        </el-form-item>

        <div class="settlementType-style" v-if="baseInfo.settleMode === 1">
          <div class="flex-box" v-if="baseInfo.settleMethod != 2">
            <el-form-item
              label="单价:"
              prop="settleRule.unitPriceYuan"
              :rules="[
                {
                  required: !((!isOpen && baseInfo.settleMethod == 0) || baseInfo.settleMethod == 2),
                  message: ' ',
                  trigger: 'blur'
                }
              ]"
            >
              <el-input-number
                placeholder=""
                v-model="baseInfo.settleRule.unitPriceYuan"
                autocomplete="off"
                controls-position="right"
                :min="1"
                :max="Infinity"
                :precision="2"
                :disabled="(!isOpen && baseInfo.settleMethod == 0) || baseInfo.settleMethod == 2"
              >
              </el-input-number>
            </el-form-item>
            <span>元</span>
          </div>
          <div class="settlement-tips" v-if="baseInfo.settleMethod != 2">
            若用线上结算，请填写调查员到手金额，到手金额
            <el-button type="text" @click="() => this.$emit('emitDialog', true)">计算器</el-button>
          </div>
          <div class="flex-box">
            <span class="pos-abs-box">
              <i>*</i>
              答卷数量:
              <el-tooltip
                effect="dark"
                content="该数量仅为参考回收数量，调查员可超额上报答卷，您可与调查员线下协商上报数量，采用线上结算时，可按照实际上报答卷数量进行结算"
                placement="top"
              >
                <div class="icon-wrap" style="margin-left: 4px">
                  <span class="icon-font ico-tips" style="font-size: 12px">&#xe65b;</span>
                </div>
              </el-tooltip>
            </span>
            <el-form-item
              label=""
              prop="settleRule.expectedQuantity"
              :rules="[{ required: !(!isOpen && baseInfo.settleMethod == 0), message: ' ', trigger: 'blur' }]"
            >
              <el-input-number
                placeholder=""
                v-model="baseInfo.settleRule.expectedQuantity"
                autocomplete="off"
                controls-position="right"
                :min="1"
                :max="Infinity"
                :precision="0"
                :disabled="!isOpen && baseInfo.settleMethod == 0"
              >
              </el-input-number>
            </el-form-item>
            <span>份</span>
          </div>
          <div class="settlement-tips" style="margin-bottom: 0" v-if="baseInfo.settleMethod != 2">
            预估费用：{{ totalPriceYuan }}元，若采用线上结算，项目预计花费 {{ totalSaleYuan }}元
          </div>
        </div>
        <div class="settlementType-style" v-if="baseInfo.settleMode === 2">
          <div class="flex-box" v-if="baseInfo.settleMethod != 2">
            <el-form-item
              label="单价:"
              prop="settleRule.unitPriceYuan"
              :rules="[
                {
                  required: !((!isOpen && baseInfo.settleMethod == 0) || baseInfo.settleMethod == 2),
                  message: ' ',
                  trigger: 'blur'
                }
              ]"
            >
              <el-input-number
                placeholder=""
                v-model.number="baseInfo.settleRule.unitPriceYuan"
                autocomplete="off"
                controls-position="right"
                :min="1"
                :max="Infinity"
                :precision="2"
                :disabled="(!isOpen && baseInfo.settleMethod == 0) || baseInfo.settleMethod == 2"
              >
              </el-input-number>
            </el-form-item>
            <span>元</span>
          </div>
          <div class="settlement-tips" v-if="baseInfo.settleMethod != 2">
            若用线上结算，请填写调查员到手金额，到手金额
            <el-button type="text" @click="() => this.$emit('emitDialog', true)">计算器</el-button>
          </div>
          <div class="flex-box">
            <span class="pos-abs-box">
              <i>*</i>
              天数:
              <el-tooltip
                effect="dark"
                content="当天只要上报答卷即记为工作 1 天，该天数仅为参考工作天数，您可与调查员线下协商工作天数，采用线上结算时，可按照实际工作天数进行结算"
                placement="top"
              >
                <div class="icon-wrap" style="margin-left: 4px">
                  <span class="icon-font ico-tips" style="font-size: 12px">&#xe65b;</span>
                </div>
              </el-tooltip>
            </span>
            <el-form-item
              label=""
              prop="settleRule.expectedQuantity"
              :rules="[{ required: !(!isOpen && baseInfo.settleMethod == 0), message: ' ', trigger: 'blur' }]"
            >
              <el-input-number
                placeholder=""
                v-model.number="baseInfo.settleRule.expectedQuantity"
                autocomplete="off"
                controls-position="right"
                :min="1"
                :max="Infinity"
                :precision="0"
                :disabled="!isOpen && baseInfo.settleMethod == 0"
              >
              </el-input-number>
            </el-form-item>
            <span>天</span>
          </div>
          <div class="settlement-tips" style="margin-bottom: 0" v-if="baseInfo.settleMethod != 2">
            <div style="display: flex">
              <div>预估费用：{{ totalPriceYuan }}元，若采用线上结算，项目预计花费 {{ totalSaleYuan }}元</div>
              <el-tooltip
                effect="dark"
                :content="`项目预计费用=预估费用*（1+${accRate}），其中${accountingRateVal}为用于调查员待缴税及平台技术服务费`"
                placement="top"
              >
                <div class="icon-wrap">
                  <span class="icon-font ico-tips">&#xe65b;</span>
                </div>
              </el-tooltip>
            </div>
          </div>
        </div>
        <div class="settlementType-style" v-if="baseInfo.settleMode === 3">
          <el-form-item class="is-require-task" style="margin-bottom: 0" label="单价:" v-if="baseInfo.settleMethod != 2">
            <div
              class="flex-settlement"
              v-for="(item, index) in baseInfo.settleRule.tiers"
              :key="index"
              :style="{ marginBottom: index === baseInfo.settleRule.tiers.length - 1 ? '0px' : '5px' }"
            >
              <span style="margin-right: 8px" v-show="index === 0">每天</span>
              <el-form-item label>
                <el-input-number
                  v-if="index === 0"
                  :disabled="true"
                  placeholder=""
                  v-model="item.quantityLowerBound"
                  autocomplete="off"
                  controls-position="right"
                  :min="0"
                  :max="Infinity"
                  :precision="0"
                >
                </el-input-number>
                <el-input-number
                  v-if="index > 0"
                  :disabled="true"
                  placeholder=""
                  :value="baseInfo.settleRule.tiers[index - 1].quantityUpperBound"
                  autocomplete="off"
                  controls-position="right"
                  :min="0"
                  :max="Infinity"
                  :precision="0"
                >
                </el-input-number>
              </el-form-item>
              <span style="margin: 0 8px">份 &lt; 完成量 ≤</span>
              <el-form-item
                label
                :prop="'settleRule.tiers[' + index + '].quantityUpperBound'"
                :rules="[
                  {
                    required: !((!isOpen && baseInfo.settleMethod == 0) || baseInfo.settleMethod == 2),
                    message: ' ',
                    trigger: 'blur'
                  }
                ]"
              >
                <el-input-number
                  placeholder=""
                  v-model="item.quantityUpperBound"
                  autocomplete="off"
                  controls-position="right"
                  :min="index > 0 ? baseInfo.settleRule.tiers[index - 1].quantityUpperBound * 1 + 1 : 1"
                  :max="Infinity"
                  @change="val => currentInputNumber(val, item, index)"
                  :precision="0"
                  :disabled="(!isOpen && baseInfo.settleMethod == 0) || baseInfo.settleMethod == 2"
                >
                </el-input-number>
              </el-form-item>
              <span style="margin: 0 8px">份，按完成量</span>
              <el-form-item
                label
                :prop="'settleRule.tiers[' + index + '].unitPriceYuan'"
                :rules="[
                  {
                    required: !((!isOpen && baseInfo.settleMethod == 0) || baseInfo.settleMethod == 2),
                    message: ' ',
                    trigger: 'blur'
                  }
                ]"
                style="margin-left: 10px"
              >
                <el-input-number
                  placeholder=""
                  v-model.number="item.unitPriceYuan"
                  autocomplete="off"
                  controls-position="right"
                  :min="1"
                  :max="Infinity"
                  :precision="2"
                  :disabled="(!isOpen && baseInfo.settleMethod == 0) || baseInfo.settleMethod == 2"
                >
                </el-input-number>
              </el-form-item>
              <span style="margin-left: 8px">元/份</span>
              <el-button v-if="index === 0" @click="handleSettlement('add', index)" class="btn-style" type="text"
                ><i class="icon-font">&#xe68c;</i></el-button
              >
              <el-button
                v-else-if="index === baseInfo.settleRule.tiers.length - 1"
                @click="handleSettlement('remove', index)"
                class="btn-style"
                type="text"
                ><i class="icon-font">&#xe68a;</i></el-button
              >
              <!-- <el-button @click="handleSettlement(index=== baseInfo.ladderSettlement.length-1 ? 'add' : 'remove')" class="btn-style" type="text"> {{index=== 0? '+':'-'}}</el-button> -->
            </div>
            <div class="settlement-tips left-0">
              若用线上结算，请填写调查员到手金额，到手金额
              <el-button type="text" @click="() => this.$emit('emitDialog', true)">计算器</el-button>
            </div>
          </el-form-item>
          <div class="flex-box">
            <el-form-item
              style="margin-bottom: 0"
              label="天数:"
              prop="settleRule.expectedQuantity"
              :rules="[{ required: !(!isOpen && baseInfo.settleMethod == 0), message: ' ', trigger: 'blur' }]"
            >
              <el-input-number
                placeholder=""
                v-model.number="baseInfo.settleRule.expectedQuantity"
                autocomplete="off"
                controls-position="right"
                :min="1"
                :max="Infinity"
                :precision="0"
                :disabled="!isOpen && baseInfo.settleMethod == 0"
              >
              </el-input-number>
            </el-form-item>
            <span>天</span>
          </div>
        </div>

        <!-- <el-form-item prop="executionQuantity" label="答卷数量:">
          <el-input type="text" v-model="baseInfo.executionQuantity"></el-input>
        </el-form-item>
        <el-form-item prop="executionSingleAmount" label="答卷单价:">
          <el-input type="text" v-model="baseInfo.executionSingleAmount"></el-input>
        </el-form-item> -->
        <el-form-item label="描述:">
          <el-input v-model="baseInfo.executionDescription" type="textarea" resize="none"></el-input>
        </el-form-item>
      </el-form>
      <div class="submit-btn" v-if="baseInfo.status != 8">
        <el-button type="primary" @click="onClickSubmit" style="width: 88px">确认</el-button>
        <el-button @click="$emit('cancel')" style="width: 88px">取消</el-button>
      </div>
    </div>
    <div class="answer-info">
      <div class="top font-bold">答卷信息</div>
      <el-form label-width="140px" v-model="answerInfo" label-position="right">
        <el-form-item label="提交数量:">{{ answerInfo.recycledQuantity }}</el-form-item>
        <el-form-item label="有效数量:">{{ answerInfo.effectiveQuantity }}</el-form-item>
      </el-form>
      <div class="submit-btn">
        <el-button type="primary" @click="onClickGo">答卷列表</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { isNum } from '@/assets/js/utils'
import { putOfflineTask } from '@/api/wenjuan/offline'
import store from '@/store'
import GlobalConfig from '@/global/config'

export default {
  name: 'showTask',
  props: {
    rows: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    const startDateDisabled = {}
    startDateDisabled.disabledDate = function (time) {
      return time.getTime() + 24 * 3600 * 1000 < Date.now()
    }
    const baseInfoNameRules = (rule, value, callback) => {
      let v = this.baseInfo[rule.fullField]
      if (!v.trim()) {
        callback(new Error('请输入任务名称'))
      }
    }
    const baseInfoExecutionValidateToRules = (rule, value, callback) => {
      let v = this.baseInfo[rule.fullField]
      if (!v) {
        callback(new Error('请选择结束时间'))
      }
    }
    const baseInfoExecutionQuantity = (rule, value, callback) => {
      let v = this.baseInfo[rule.fullField]
      if (!isNum.test(v)) {
        callback(new Error('请输入有效数字'))
      }
    }
    return {
      settleMethodMap: {
        online: 0,
        offline: 1,
        neednot: 2
      },
      btnCheckedMap: {
        0: 'online',
        1: 'offline',
        2: 'neednot'
      },
      btnChecked: 'online',
      isOpen: false,
      startDateDisabled,
      taskInfo: null,
      baseInfoRules: {
        executionName: [{ required: true, validator: baseInfoNameRules, trigger: 'blur' }],
        executionValidateTo: [{ required: true, validator: baseInfoExecutionValidateToRules, trigger: 'blur' }],
        executionQuantity: [{ required: true, validator: baseInfoExecutionQuantity, trigger: 'blur' }],
        executionSingleAmount: [{ required: true, validator: baseInfoExecutionQuantity, trigger: 'blur' }]
      },
      baseInfo: {
        id: 0,
        executionName: '',
        executorPhone: '',
        executionValidateTo: '',
        executionQuantity: 0,
        executionSingleAmount: 0,
        executionDescription: '',
        settleMethod: 0,
        settleMode: 1,
        settleRule: {
          unitPriceYuan: undefined, //单价 多少元/天  多少元/份
          expectedQuantity: undefined, // 数量 多少份 | 多少天
          tiers: [
            {
              quantityLowerBound: 1,
              quantityUpperBound: undefined,
              unitPriceYuan: undefined
            }
          ]
        }
      },
      answerInfo: {
        recycledQuantity: 0,
        effectiveQuantity: 0
      }
    }
  },
  computed: {
    totalPriceYuan () {
      if (this.baseInfo.settleRule.expectedQuantity && this.baseInfo.settleRule.unitPriceYuan) {
        return (this.baseInfo.settleRule.expectedQuantity * this.baseInfo.settleRule.unitPriceYuan).toFixed(2)
      } else {
        return 0
      }
    },
    totalSaleYuan () {
      if (this.baseInfo.settleRule.expectedQuantity && this.baseInfo.settleRule.unitPriceYuan) {
        return ((1 + this.accRate * 1) * (this.baseInfo.settleRule.expectedQuantity * this.baseInfo.settleRule.unitPriceYuan)).toFixed(2)
      } else {
        return 0
      }
    },
    accountingRateVal() {
      const { accountingRate = 0 } = this.$store.getters || {};
      return accountingRate === null || accountingRate === 0 ? '6.5%' : `${accountingRate}%`
    },
    accRate() {
      const { accountingRate = 0 } = this.$store.getters || {};
      return accountingRate === null || accountingRate === 0 ? '0.065' : (accountingRate / 100).toFixed(3)
    }
  },
  methods: {
    toOpen() {
      window.open(
        `${window.location.origin + process.env.VUE_APP_PRE_URL}/#/cost-settlement`
      )
    },
    changeSettleMethod(btnType) {
      this.btnChecked = btnType
      this.baseInfo.settleMethod = this.settleMethodMap[btnType]
      this.changeSettlementType(1)
    },
    onClickGo() {
      // this.getTopMenu('答卷列表').then(res => {
      if (this.rows.rowId) {
        this.$router.push({
          path: `/survey/${GlobalConfig.getSurveyId()}/data/data-download`,
          query: {
            channel: '9'
          }
        })
      } else {
        this.$router.push({
          path: `/survey/${GlobalConfig.getSurveyId()}/data/data-download`,
          query: {
            channel: '2'
          }
        })
      }
      // })
    },
    onClickSubmit() {
      if (!this.isOpen && this.baseInfo.settleMethod == 0) {
        this.$message({
          message: '尚未开通费用结算，无法设定线上结算',
          type: 'warning'
        })
        return
      }
      this.$confirm('确定保存修改内容?', '保存', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let taskInfo = this.baseInfo
          let postData = {}
          if (this.baseInfo.settleMode === 3) {
            const cloneLadderSettlement = [...this.baseInfo.settleRule.tiers]
            cloneLadderSettlement.forEach((it, i, arr) => {
              if (i > 0) {
                it.quantityLowerBound = arr[i - 1].quantityUpperBound * 1
              }
            })
            postData = {
              ...this.baseInfo,
              settleRule: {
                ...this.baseInfo.settleRule,
                tiers: cloneLadderSettlement
              }
            }
            // postData.ladderSettlement =cloneLadderSettlement;
            this.baseInfo = { ...postData }
          }

          putOfflineTask({ ...this.baseInfo, executionBy: this.taskInfo.executionBy }).then(res => {
            if (res.data.code != 0) {
              this.$message.error(res.data.msg)
              return
            }
            this.$message({
              type: 'success',
              message: '保存成功!'
            })
          })
        })
        .catch(() => {
          this.initInfo()
        })
    },
    initInfo() {
      this.baseInfo = {
        id: this.taskInfo.offlineId,
        executionName: this.taskInfo.executionName,
        executorPhone: this.taskInfo.executorPhone,
        executionValidateTo: this.taskInfo.executionValidateTo,
        executionQuantity: this.taskInfo.executionQuantity,
        executionSingleAmount: this.taskInfo.executionSingleAmount,
        executionDescription: this.taskInfo.executionDescription,
        status: this.taskInfo.status,
        settleMethod: this.taskInfo.settleMethod || 0,
        settleMode: this.taskInfo.settleMode,
        settleRule: this.taskInfo.settleRule || {
          unitPriceYuan: undefined, //单价 多少元/天  多少元/份
          expectedQuantity: undefined, // 数量 多少份 | 多少天
          tiers: [
            {
              quantityLowerBound: 1,
              quantityUpperBound: undefined,
              unitPriceYuan: undefined
            }
          ]
        }
      }
      this.btnChecked = this.btnCheckedMap[this.baseInfo.settleMethod]
      this.answerInfo = {
        recycledQuantity: this.taskInfo.recycledQuantity,
        effectiveQuantity: this.taskInfo.effectiveQuantity
      }
    },
    // 监听input-number值的变化
    currentInputNumber(val, item, currentIndex) {
      const baseSettleRule = JSON.parse(JSON.stringify(this.baseInfo.settleRule))
      baseSettleRule.tiers.forEach((it, i, arr) => {
        if (i > currentIndex) {
          it.quantityUpperBound = arr[i - 1].quantityUpperBound + 1
        }
      })
      this.baseInfo.settleRule = {
        ...this.baseInfo.settleRule,
        tiers: baseSettleRule.tiers
      }
    },
    // 切换结算方式
    changeSettlementType(val) {
      this.$refs['taskRuleForm'].clearValidate()
      this.baseInfo = {
        ...this.baseInfo,
        settleMode: val,
        settleRule: {
          unitPriceYuan: undefined, //单价 多少元/天  多少元/份
          expectedQuantity: undefined, // 数量 多少份 | 多少天
          tiers: [
            {
              quantityLowerBound: 0,
              quantityUpperBound: undefined,
              unitPriceYuan: undefined
            }
          ]
        }
      }
    },
    handleSettlement(type, index) {
      console.log(type)
      if (type === 'add') {
        const validateArr = []
        this.baseInfo.settleRule.tiers.forEach((it, i) => {
          validateArr.push(`settleRule.tiers[${i}].quantityUpperBound`)
          validateArr.push(`settleRule.tiers[${i}].unitPriceYuan`)
        })
        let validFlag = false
        validateArr.forEach(item => {
          this.$refs['taskRuleForm'].validateField(
            validateArr,
            valid => (validFlag = valid ? false : true) // 定义是否通过表单验证
          )
        })
        console.log('validateArr:', validateArr)
        if (validFlag) {
          if (this.baseInfo.settleRule.tiers.length < 5) {
            const lastTiers = this.baseInfo.settleRule.tiers[this.baseInfo.settleRule.tiers.length - 1]
            const lastObj = { quantityUpperBound: lastTiers.quantityUpperBound, unitPriceYuan: lastTiers.unitPriceYuan }

            const flagDouble = Object.values(lastObj).includes(undefined)
            if (flagDouble) {
              this.$message.error('请完善表单项')
              return
            }
            const cloneLadderSettlement = this.baseInfo.settleRule.tiers
            cloneLadderSettlement.push({
              quantityLowerBound: undefined,
              quantityUpperBound: undefined,
              unitPriceYuan: undefined
            })
            this.baseInfo.settleRule.tiers = cloneLadderSettlement
          } else {
            this.$message.error('最多只能添加5条数据')
          }
        } else {
          this.$message.error('请完善表单项')
        }
      } else if (type === 'remove') {
        const cloneLadderSettlement = this.baseInfo.settleRule.tiers

        this.baseInfo.settleRule.tiers = cloneLadderSettlement.filter((it, i) => index !== i)
      }
    }
  },
  created() {
    this.isOpen = this.$store.getters.settlementType !== 1
    this.taskInfo = this.rows
    this.initInfo()
  }
}
</script>

<style scoped lang="scss">
.showTask {
  .goback {
    cursor: pointer;

    &:hover {
      opacity: 0.7;
    }
  }

  .base-info,
  .answer-info {
    @apply px-6 py-4;

    .top {
      font-size: 16px;
      color: rgba(0, 0, 0, 0.85);
    }

    .el-form {
      width: 760px;
      margin: 0 auto;

      .el-form-item {
        // margin-bottom: 22px;
      }

      .el-form-input {
        width: 220px;
      }
    }
  }

  .submit-btn {
    margin-top: 30px;
    text-align: center;
  }
  .settlementType-style .flex-box .pos-abs-box {
    position: absolute;
    display: flex;
    justify-content: flex-end;
    width: 128px;
    padding-right: 12px;
    i {
      content: '*';
      color: #e34152;
      margin-right: 4px;
    }
  }
  .settlementType-style .flex-settlement .el-form-item {
    margin-bottom: 0 !important;
  }
}
.btn-box {
  @apply flex justify-center;
  padding: 10px;
  min-height: 116px;
  width: 200px;
  border-radius: 2px;
  cursor: pointer;
  line-height: 16px;
  position: relative;
  .position-checkbox {
    position: absolute;
    right: 0;
    top: -2px;
  }
  &.btn1 {
    border: 1px solid #cccccc;
  }
  &.btn2 {
    border: 1px solid #cccccc;
    margin-left: 12px;
  }
  &.btn1.btn-checked,
  &.btn2.btn-checked {
    background: rgba(39, 117, 232, 0.1);
    border: 1px solid var(--theme-color) !important;
  }
  .tujian {
    border: 1px solid #faad14;
    border-radius: 8px;
    width: 34px;
    height: 16px;
    font-weight: 500;
    font-size: 12px;
  }
}
// .btn-checked div {
//   div {
//     color: #2775e8 !important;
//   }
//   i {
//     color: #2775e8 !important;
//   }
// }
.btn-box:hover {
  &.btn1,
  &.btn2 {
    background: rgba(39, 117, 232, 0.1);
    border: 1px solid var(--theme-color) !important;
    // div {
    //   div {
    //     color: #2775e8 !important;
    //   }
    //   i {
    //     color: #2775e8 !important;
    //   }
    // }
  }
}
</style>
